import * as React from 'react';

import _t from 'i18n!nls/enroll';

const S12nSubscriptionVPropSDP = () => (
  <strong className="body-2-text">{_t('Subscribe to the entire series and get access to:')}</strong>
);

export default S12nSubscriptionVPropSDP;
